import React, { useState, useEffect} from 'react';
import { useHistory } from 'react-router-dom';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Database, DataContextType } from './Managers/DataManager';
import Settings, { defaultSettings, SettingsData} from './Managers/Settings';
import VideoManager, { VideoContextData } from './Managers/VideoManager';
import { ProgramModel } from './Models/Program.interface';
import { VideoModel } from './Models/Video.interface';

export const SettingsContext = React.createContext<SettingsData>({...defaultSettings()});
export const VideoContext = React.createContext<VideoContextData>({} as VideoContextData)
export const ProgramContext = React.createContext<DataContextType>({} as DataContextType)

export class SettingsProvider extends React.Component<any, SettingsData>{

        constructor(props){
            super(props)
            this.state = Settings.data 
            
        }

        componentDidMount(){
            Settings.get().subscribe(settings => {
               this.setState({...settings}) 
            })
        }

        render(){
            return(
                <SettingsContext.Provider value={this.state}>
                    {this.props.children}
                </SettingsContext.Provider>
            )
        }
    
}

export const VideoProvider = props => {

    const [ currentVideo, setCurrentVideo] = useState<VideoModel | null>()
    const [ url, setUrl ]  = useState<string | null>()
    const history = useHistory()

    const leaving = new Subject<void>()
    useEffect(() => {

        VideoManager.getCurrentVideo()
        .pipe(takeUntil(leaving))
        .subscribe(setCurrentVideo)

        VideoManager.getURL()
        .pipe(takeUntil(leaving))
        .subscribe(setUrl)

        VideoManager.getLocationChange()
        .pipe(takeUntil(leaving))
        .subscribe(path => {
            // console.log(history)
            if(path){
                history?.push?.(path)
            }
        })

        

        return () => leaving.next()
    }, [])

    let value = {currentVideo, url}

    return(
        <VideoContext.Provider value={value}>
            {props.children}
        </VideoContext.Provider>
    )

}



export const ProgramProvider = props => {

    const [ programs, setPrograms] = useState<ProgramModel[] | null>()

    const leaving = new Subject<void>()
    useEffect(() => {

        Database.get('/programs')
        .then(obs => {
            obs.pipe(takeUntil(leaving))
            .subscribe(setPrograms)
        })
        

        return () => leaving.next()
    }, [])

    const value = {programs}
    return(
        <ProgramContext.Provider value={value}>
            {props.children}
        </ProgramContext.Provider>
    )

}

